function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 302);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  t.exports = n(53)();
},,,,,,, function (t, e) {
  t.exports = require("react-dom");
},, function (t, e, n) {
  var r;
  !function () {
    "use strict";

    var n = {}.hasOwnProperty;

    function o() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        var r = arguments[e];

        if (r) {
          var a = _typeof(r);

          if ("string" === a || "number" === a) t.push(r);else if (Array.isArray(r) && r.length) {
            var i = o.apply(null, r);
            i && t.push(i);
          } else if ("object" === a) for (var c in r) {
            n.call(r, c) && r[c] && t.push(c);
          }
        }
      }

      return t.join(" ");
    }

    void 0 !== t && t.exports ? (o.default = o, t.exports = o) : void 0 === (r = function () {
      return o;
    }.apply(e, [])) || (t.exports = r);
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  e.default = function (t, e, n) {
    var r = Object.keys(e),
        o = n && n.handleMissingStyleName || "throw";
    return t.split(" ").filter(function (t) {
      return t;
    }).map(function (t) {
      if (function (t) {
        return -1 !== t.indexOf(".");
      }(t)) return function (t, e, n) {
        var r = t.split("."),
            o = r[0],
            a = r[1],
            i = n || "throw";

        if (!a) {
          if ("throw" === i) throw new Error("Invalid style name: " + t);
          if ("warn" !== i) return null;
        }

        if (!e[o]) {
          if ("throw" === i) throw new Error("CSS module import does not exist: " + o);
          if ("warn" !== i) return null;
        }

        if (!e[o][a]) {
          if ("throw" === i) throw new Error("CSS module does not exist: " + a);
          if ("warn" !== i) return null;
        }

        return e[o][a];
      }(t, e, o);
      if (0 === r.length) throw new Error("Cannot use styleName attribute for style name '" + t + "' without importing at least one stylesheet.");
      if (r.length > 1) throw new Error("Cannot use anonymous style name '" + t + "' with more than one stylesheet import.");
      var n = e[r[0]];
      if (!n[t] && "throw" === o) throw new Error("Could not resolve the styleName '" + t + "'.");
      return n[t];
    }).filter(function (t) {
      return t;
    }).join(" ");
  };
},, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(11),
      o = n.n(r),
      a = n(0),
      i = n.n(a),
      c = n(1),
      u = n.n(c),
      s = n(10),
      p = n.n(s),
      l = (n(182), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      f = {
    "./styles.scss": {
      "c-icon": "wri_api__c-icon",
      "-tiny": "wri_api__-tiny",
      "-smaller": "wri_api__-smaller",
      "-small": "wri_api__-small",
      "-medium": "wri_api__-medium",
      "-big": "wri_api__-big",
      "-huge": "wri_api__-huge",
      "-star": "wri_api__-star"
    }
  };

  var b = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i.a.PureComponent), l(e, [{
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this.props,
            a = r.name,
            c = r.className,
            u = r.style,
            s = p()((n = !!c, (e = c) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return i.a.createElement("svg", {
          style: u,
          className: o()("c-icon " + s, f)
        }, i.a.createElement("use", {
          xlinkHref: "#" + a
        }));
      }
    }]), e;
  }();

  b.propTypes = {
    name: u.a.string,
    className: u.a.string,
    style: u.a.object
  }, b.defaultProps = {
    name: "",
    className: "",
    style: {}
  }, e.default = b;
},,,,,,,,,,, function (t, e, n) {
  var r = n(126),
      o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
      a = r || o || Function("return this")();
  t.exports = a;
},,,,,,,,,,, function (t, e) {
  var n = Array.isArray;
  t.exports = n;
},, function (t, e, n) {
  var r = n(118);

  t.exports = function (t, e) {
    return r(t, e);
  };
},,, function (t, e, n) {
  var r = n(248),
      o = n(251);

  t.exports = function (t, e) {
    var n = o(t, e);
    return r(n) ? n : void 0;
  };
},,,,,,,,,, function (t, e, n) {
  var r = n(70),
      o = n(235),
      a = n(236),
      i = "[object Null]",
      c = "[object Undefined]",
      u = r ? r.toStringTag : void 0;

  t.exports = function (t) {
    return null == t ? void 0 === t ? c : i : u && u in Object(t) ? o(t) : a(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    return null != t && "object" == _typeof(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = _typeof(t);

    return null != t && ("object" == e || "function" == e);
  };
}, function (t, e, n) {
  "use strict";

  var r = n(54);

  function o() {}

  t.exports = function () {
    function t(t, e, n, o, a, i) {
      if (i !== r) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = o, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
},,,,,,,,,,,,,,, function (t, e) {
  var n;

  n = function () {
    return this;
  }();

  try {
    n = n || Function("return this")() || (0, eval)("this");
  } catch (t) {
    "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
  }

  t.exports = n;
}, function (t, e, n) {
  var r = n(24).Symbol;
  t.exports = r;
},, function (t, e, n) {
  var r = n(238),
      o = n(239),
      a = n(240),
      i = n(241),
      c = n(242);

  function u(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  u.prototype.clear = r, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = c, t.exports = u;
}, function (t, e, n) {
  var r = n(105);

  t.exports = function (t, e) {
    for (var n = t.length; n--;) {
      if (r(t[n][0], e)) return n;
    }

    return -1;
  };
}, function (t, e, n) {
  var r = n(40)(Object, "create");
  t.exports = r;
}, function (t, e, n) {
  var r = n(260);

  t.exports = function (t, e) {
    var n = t.__data__;
    return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
  };
},, function (t, e, n) {
  var r = n(127),
      o = n(109);

  t.exports = function (t) {
    return null != t && o(t.length) && !r(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
      enumerable: !0,
      get: function get() {
        return t.l;
      }
    }), Object.defineProperty(t, "id", {
      enumerable: !0,
      get: function get() {
        return t.i;
      }
    }), t.webpackPolyfill = 1), t;
  };
},,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
  var r = n(234),
      o = n(51),
      a = Object.prototype,
      i = a.hasOwnProperty,
      c = a.propertyIsEnumerable,
      u = r(function () {
    return arguments;
  }()) ? r : function (t) {
    return o(t) && i.call(t, "callee") && !c.call(t, "callee");
  };
  t.exports = u;
}, function (t, e, n) {
  var r = n(40)(n(24), "Map");
  t.exports = r;
},,,,, function (t, e) {
  t.exports = function (t, e) {
    return t === e || t != t && e != e;
  };
}, function (t, e, n) {
  var r = n(252),
      o = n(259),
      a = n(261),
      i = n(262),
      c = n(263);

  function u(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  u.prototype.clear = r, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = c, t.exports = u;
}, function (t, e, n) {
  (function (t) {
    var r = n(24),
        o = n(282),
        a = "object" == _typeof(e) && e && !e.nodeType && e,
        i = a && "object" == _typeof(t) && t && !t.nodeType && t,
        c = i && i.exports === a ? r.Buffer : void 0,
        u = (c ? c.isBuffer : void 0) || o;
    t.exports = u;
  }).call(this, n(78)(t));
}, function (t, e, n) {
  var r = n(283),
      o = n(195),
      a = n(284),
      i = a && a.isTypedArray,
      c = i ? o(i) : r;
  t.exports = c;
}, function (t, e) {
  var n = 9007199254740991;

  t.exports = function (t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
  };
},,,,,,,,, function (t, e, n) {
  var r = n(264),
      o = n(51);

  t.exports = function t(e, n, a, i, c) {
    return e === n || (null == e || null == n || !o(e) && !o(n) ? e != e && n != n : r(e, n, a, i, t, c));
  };
}, function (t, e, n) {
  var r = n(280),
      o = n(196),
      a = n(77);

  t.exports = function (t) {
    return a(t) ? r(t) : o(t);
  };
}, function (t, e) {
  var n = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;

  t.exports = function (t, e) {
    var o = _typeof(t);

    return !!(e = null == e ? n : e) && ("number" == o || "symbol" != o && r.test(t)) && t > -1 && t % 1 == 0 && t < e;
  };
},,,,,, function (t, e, n) {
  (function (e) {
    var n = "object" == _typeof(e) && e && e.Object === Object && e;
    t.exports = n;
  }).call(this, n(69));
}, function (t, e, n) {
  var r = n(50),
      o = n(52),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      c = "[object GeneratorFunction]",
      u = "[object Proxy]";

  t.exports = function (t) {
    if (!o(t)) return !1;
    var e = r(t);
    return e == i || e == c || e == a || e == u;
  };
}, function (t, e) {
  var n = Function.prototype.toString;

  t.exports = function (t) {
    if (null != t) {
      try {
        return n.call(t);
      } catch (t) {}

      try {
        return t + "";
      } catch (t) {}
    }

    return "";
  };
}, function (t, e, n) {
  var r = n(265),
      o = n(268),
      a = n(269),
      i = 1,
      c = 2;

  t.exports = function (t, e, n, u, s, p) {
    var l = n & i,
        f = t.length,
        b = e.length;
    if (f != b && !(l && b > f)) return !1;
    var h = p.get(t);
    if (h && p.get(e)) return h == e;
    var y = -1,
        m = !0,
        v = n & c ? new r() : void 0;

    for (p.set(t, e), p.set(e, t); ++y < f;) {
      var d = t[y],
          _ = e[y];
      if (u) var w = l ? u(_, d, y, e, t, p) : u(d, _, y, t, e, p);

      if (void 0 !== w) {
        if (w) continue;
        m = !1;
        break;
      }

      if (v) {
        if (!o(e, function (t, e) {
          if (!a(v, e) && (d === t || s(d, t, n, u, p))) return v.push(e);
        })) {
          m = !1;
          break;
        }
      } else if (d !== _ && !s(d, _, n, u, p)) {
        m = !1;
        break;
      }
    }

    return p.delete(t), p.delete(e), m;
  };
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
  t.exports = {
    "c-icon": "wri_api__c-icon",
    "-tiny": "wri_api__-tiny",
    "-smaller": "wri_api__-smaller",
    "-small": "wri_api__-small",
    "-medium": "wri_api__-medium",
    "-big": "wri_api__-big",
    "-huge": "wri_api__-huge",
    "-star": "wri_api__-star"
  };
},,,,,,,,,,, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = e.length, o = t.length; ++n < r;) {
      t[o + n] = e[n];
    }

    return t;
  };
}, function (t, e, n) {
  var r = n(72),
      o = n(243),
      a = n(244),
      i = n(245),
      c = n(246),
      u = n(247);

  function s(t) {
    var e = this.__data__ = new r(t);
    this.size = e.size;
  }

  s.prototype.clear = o, s.prototype.delete = a, s.prototype.get = i, s.prototype.has = c, s.prototype.set = u, t.exports = s;
}, function (t, e) {
  t.exports = function (t) {
    return function (e) {
      return t(e);
    };
  };
}, function (t, e, n) {
  var r = n(197),
      o = n(285),
      a = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    if (!r(t)) return o(t);
    var e = [];

    for (var n in Object(t)) {
      a.call(t, n) && "constructor" != n && e.push(n);
    }

    return e;
  };
}, function (t, e) {
  var n = Object.prototype;

  t.exports = function (t) {
    var e = t && t.constructor;
    return t === ("function" == typeof e && e.prototype || n);
  };
}, function (t, e, n) {
  var r = n(287),
      o = n(100),
      a = n(288),
      i = n(289),
      c = n(290),
      u = n(50),
      s = n(128),
      p = s(r),
      l = s(o),
      f = s(a),
      b = s(i),
      h = s(c),
      y = u;
  (r && "[object DataView]" != y(new r(new ArrayBuffer(1))) || o && "[object Map]" != y(new o()) || a && "[object Promise]" != y(a.resolve()) || i && "[object Set]" != y(new i()) || c && "[object WeakMap]" != y(new c())) && (y = function y(t) {
    var e = u(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        r = n ? s(n) : "";
    if (r) switch (r) {
      case p:
        return "[object DataView]";

      case l:
        return "[object Map]";

      case f:
        return "[object Promise]";

      case b:
        return "[object Set]";

      case h:
        return "[object WeakMap]";
    }
    return e;
  }), t.exports = y;
},,, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      a = n(1),
      i = n.n(a),
      c = n(8),
      u = n(37),
      s = n.n(u),
      p = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      l = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function f(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var b = ("undefined" != typeof window ? window : {}).L,
      h = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var a = arguments.length, i = Array(a), u = 0; u < a; u++) {
        i[u] = arguments[u];
      }

      return n = r = f(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.setPopup = function () {
        var t = r.props,
            e = t.map,
            n = t.latlng;
        n && e || r.removePopup();
        var o = r.buildPopup();
        n && e && r.popup.setLatLng(n).setContent(o).openOn(e);
      }, r.buildPopup = function () {
        var t = r.props.children,
            e = document.createElement("div");
        return Object(c.render)(o.a.Children.map(t, function (t) {
          return o.a.isValidElement(t) && "string" != typeof t.type ? o.a.cloneElement(t, p({}, r.props, {
            popup: r.popup
          })) : t;
        }), e), e;
      }, r.updatePopup = function () {
        r.popup.setContent(r.buildPopup());
      }, r.removePopup = function () {
        r.popup && r.popup.remove();
      }, f(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["Component"]), l(e, [{
      key: "componentDidMount",
      value: function value() {
        void 0 !== b && (this.popup = this.popup || b.popup({
          maxWidth: 400,
          minWidth: 240
        }), this.props.onReady(this.popup));
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.latlng,
            n = t.data,
            r = this.props,
            o = r.latlng,
            a = r.data;
        s()(e, o) || this.setPopup(), s()(n, a) || this.updatePopup();
      }
    }, {
      key: "render",
      value: function value() {
        return null;
      }
    }]), e;
  }();

  h.propTypes = {
    children: i.a.node.isRequired,
    map: i.a.object.isRequired,
    latlng: i.a.object,
    data: i.a.object,
    onReady: i.a.func
  }, h.defaultProps = {
    latlng: {},
    data: {},
    onReady: function onReady() {}
  }, e.a = h;
}, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      a = n(10),
      i = n.n(a),
      c = n(1),
      u = n.n(c),
      s = (n(487), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var p = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), s(e, [{
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this.props,
            a = r.customClass,
            c = r.children,
            u = i()((n = !!a, (e = a) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return o.a.createElement("div", {
          className: (u ? u + " " : "") + "wri_api__c-map-controls"
        }, o.a.createElement("ul", {
          className: "wri_api__map-controls-list"
        }, o.a.Children.map(c, function (t, e) {
          return o.a.isValidElement(t) && o.a.createElement("li", {
            className: "wri_api__map-controls-list-item",
            key: e
          }, o.a.cloneElement(t));
        })));
      }
    }]), e;
  }();

  p.propTypes = {
    children: u.a.node.isRequired,
    customClass: u.a.string
  }, p.defaultProps = {
    customClass: null
  }, e.a = p;
}, function (t, e, n) {
  "use strict";

  var r = n(11),
      o = n.n(r),
      a = n(0),
      i = n.n(a),
      c = n(1),
      u = n.n(c),
      s = n(10),
      p = n.n(s),
      l = n(13),
      f = (n(489), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      b = {
    "./styles.scss": {
      "c-zoom-control": "wri_api__c-zoom-control",
      "zoom-control-btn": "wri_api__zoom-control-btn",
      "-disabled": "wri_api__-disabled"
    }
  };

  function h(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function y(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var m = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }

      return n = r = y(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.state = {
        zoom: r.props.map.getZoom()
      }, r.getZoom = function () {
        r.setState({
          zoom: r.props.map.getZoom()
        });
      }, r.increaseZoom = function () {
        var t = r.props.map.getZoom(),
            e = r.props.map.getMaxZoom();
        r.setState({
          zoom: t === e ? t : t + 1
        }, function () {
          r.props.map.setZoom(r.state.zoom);
        });
      }, r.decreaseZoom = function () {
        var t = r.props.map.getZoom(),
            e = r.props.map.getMinZoom();
        r.setState({
          zoom: t === e ? t : t - 1
        }, function () {
          r.props.map.setZoom(r.state.zoom);
        });
      }, y(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a["PureComponent"]), f(e, [{
      key: "componentWillMount",
      value: function value() {
        this.props.map.on("zoomend", this.getZoom);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.map.off("zoomend", this.getZoom);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.className,
            n = t.customClass,
            r = this.state.zoom,
            a = this.props.map.getMaxZoom(),
            c = this.props.map.getMinZoom(),
            u = p()("c-zoom-control", h({}, e, !!e)),
            s = p()(h({}, n, !!n)),
            f = p()("zoom-control-btn", {
          "-disabled": r === a
        }),
            y = p()("zoom-control-btn", {
          "-disabled": r === c
        });
        return i.a.createElement("div", {
          className: (s ? s + " " : "") + o()(u, b)
        }, i.a.createElement("button", {
          type: "button",
          disabled: r === a,
          onClick: this.increaseZoom,
          className: o()(f, b)
        }, i.a.createElement(l.default, {
          name: "icon-plus"
        })), i.a.createElement("button", {
          type: "button",
          disabled: r === c,
          onClick: this.decreaseZoom,
          className: o()(y, b)
        }, i.a.createElement(l.default, {
          name: "icon-minus"
        })));
      }
    }]), e;
  }();

  m.propTypes = {
    map: u.a.object.isRequired,
    className: u.a.string,
    customClass: u.a.string
  }, m.defaultProps = {
    className: null,
    customClass: null
  }, e.a = m;
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
  var r = n(50),
      o = n(51),
      a = "[object Arguments]";

  t.exports = function (t) {
    return o(t) && r(t) == a;
  };
}, function (t, e, n) {
  var r = n(70),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      c = r ? r.toStringTag : void 0;

  t.exports = function (t) {
    var e = a.call(t, c),
        n = t[c];

    try {
      t[c] = void 0;
      var r = !0;
    } catch (t) {}

    var o = i.call(t);
    return r && (e ? t[c] = n : delete t[c]), o;
  };
}, function (t, e) {
  var n = Object.prototype.toString;

  t.exports = function (t) {
    return n.call(t);
  };
},, function (t, e) {
  t.exports = function () {
    this.__data__ = [], this.size = 0;
  };
}, function (t, e, n) {
  var r = n(73),
      o = Array.prototype.splice;

  t.exports = function (t) {
    var e = this.__data__,
        n = r(e, t);
    return !(n < 0 || (n == e.length - 1 ? e.pop() : o.call(e, n, 1), --this.size, 0));
  };
}, function (t, e, n) {
  var r = n(73);

  t.exports = function (t) {
    var e = this.__data__,
        n = r(e, t);
    return n < 0 ? void 0 : e[n][1];
  };
}, function (t, e, n) {
  var r = n(73);

  t.exports = function (t) {
    return r(this.__data__, t) > -1;
  };
}, function (t, e, n) {
  var r = n(73);

  t.exports = function (t, e) {
    var n = this.__data__,
        o = r(n, t);
    return o < 0 ? (++this.size, n.push([t, e])) : n[o][1] = e, this;
  };
}, function (t, e, n) {
  var r = n(72);

  t.exports = function () {
    this.__data__ = new r(), this.size = 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = this.__data__,
        n = e.delete(t);
    return this.size = e.size, n;
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.get(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.has(t);
  };
}, function (t, e, n) {
  var r = n(72),
      o = n(100),
      a = n(106),
      i = 200;

  t.exports = function (t, e) {
    var n = this.__data__;

    if (n instanceof r) {
      var c = n.__data__;
      if (!o || c.length < i - 1) return c.push([t, e]), this.size = ++n.size, this;
      n = this.__data__ = new a(c);
    }

    return n.set(t, e), this.size = n.size, this;
  };
}, function (t, e, n) {
  var r = n(127),
      o = n(249),
      a = n(52),
      i = n(128),
      c = /^\[object .+?Constructor\]$/,
      u = Function.prototype,
      s = Object.prototype,
      p = u.toString,
      l = s.hasOwnProperty,
      f = RegExp("^" + p.call(l).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  t.exports = function (t) {
    return !(!a(t) || o(t)) && (r(t) ? f : c).test(i(t));
  };
}, function (t, e, n) {
  var r,
      o = n(250),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

  t.exports = function (t) {
    return !!a && a in t;
  };
}, function (t, e, n) {
  var r = n(24)["__core-js_shared__"];
  t.exports = r;
}, function (t, e) {
  t.exports = function (t, e) {
    return null == t ? void 0 : t[e];
  };
}, function (t, e, n) {
  var r = n(253),
      o = n(72),
      a = n(100);

  t.exports = function () {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (a || o)(),
      string: new r()
    };
  };
}, function (t, e, n) {
  var r = n(254),
      o = n(255),
      a = n(256),
      i = n(257),
      c = n(258);

  function u(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  u.prototype.clear = r, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = c, t.exports = u;
}, function (t, e, n) {
  var r = n(74);

  t.exports = function () {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
  };
}, function (t, e, n) {
  var r = n(74),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    var e = this.__data__;

    if (r) {
      var n = e[t];
      return n === o ? void 0 : n;
    }

    return a.call(e, t) ? e[t] : void 0;
  };
}, function (t, e, n) {
  var r = n(74),
      o = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    var e = this.__data__;
    return r ? void 0 !== e[t] : o.call(e, t);
  };
}, function (t, e, n) {
  var r = n(74),
      o = "__lodash_hash_undefined__";

  t.exports = function (t, e) {
    var n = this.__data__;
    return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? o : e, this;
  };
}, function (t, e, n) {
  var r = n(75);

  t.exports = function (t) {
    var e = r(this, t).delete(t);
    return this.size -= e ? 1 : 0, e;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = _typeof(t);

    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
  };
}, function (t, e, n) {
  var r = n(75);

  t.exports = function (t) {
    return r(this, t).get(t);
  };
}, function (t, e, n) {
  var r = n(75);

  t.exports = function (t) {
    return r(this, t).has(t);
  };
}, function (t, e, n) {
  var r = n(75);

  t.exports = function (t, e) {
    var n = r(this, t),
        o = n.size;
    return n.set(t, e), this.size += n.size == o ? 0 : 1, this;
  };
}, function (t, e, n) {
  var r = n(194),
      o = n(129),
      a = n(270),
      i = n(274),
      c = n(198),
      u = n(35),
      s = n(107),
      p = n(108),
      l = 1,
      f = "[object Arguments]",
      b = "[object Array]",
      h = "[object Object]",
      y = Object.prototype.hasOwnProperty;

  t.exports = function (t, e, n, m, v, d) {
    var _ = u(t),
        w = u(e),
        j = _ ? b : c(t),
        g = w ? b : c(e),
        x = (j = j == f ? h : j) == h,
        O = (g = g == f ? h : g) == h,
        P = j == g;

    if (P && s(t)) {
      if (!s(e)) return !1;
      _ = !0, x = !1;
    }

    if (P && !x) return d || (d = new r()), _ || p(t) ? o(t, e, n, m, v, d) : a(t, e, j, n, m, v, d);

    if (!(n & l)) {
      var E = x && y.call(t, "__wrapped__"),
          z = O && y.call(e, "__wrapped__");

      if (E || z) {
        var k = E ? t.value() : t,
            S = z ? e.value() : e;
        return d || (d = new r()), v(k, S, n, m, d);
      }
    }

    return !!P && (d || (d = new r()), i(t, e, n, m, v, d));
  };
}, function (t, e, n) {
  var r = n(106),
      o = n(266),
      a = n(267);

  function i(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.__data__ = new r(); ++e < n;) {
      this.add(t[e]);
    }
  }

  i.prototype.add = i.prototype.push = o, i.prototype.has = a, t.exports = i;
}, function (t, e) {
  var n = "__lodash_hash_undefined__";

  t.exports = function (t) {
    return this.__data__.set(t, n), this;
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.has(t);
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
      if (e(t[n], n, t)) return !0;
    }

    return !1;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    return t.has(e);
  };
}, function (t, e, n) {
  var r = n(70),
      o = n(271),
      a = n(105),
      i = n(129),
      c = n(272),
      u = n(273),
      s = 1,
      p = 2,
      l = "[object Boolean]",
      f = "[object Date]",
      b = "[object Error]",
      h = "[object Map]",
      y = "[object Number]",
      m = "[object RegExp]",
      v = "[object Set]",
      d = "[object String]",
      _ = "[object Symbol]",
      w = "[object ArrayBuffer]",
      j = "[object DataView]",
      g = r ? r.prototype : void 0,
      x = g ? g.valueOf : void 0;

  t.exports = function (t, e, n, r, g, O, P) {
    switch (n) {
      case j:
        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
        t = t.buffer, e = e.buffer;

      case w:
        return !(t.byteLength != e.byteLength || !O(new o(t), new o(e)));

      case l:
      case f:
      case y:
        return a(+t, +e);

      case b:
        return t.name == e.name && t.message == e.message;

      case m:
      case d:
        return t == e + "";

      case h:
        var E = c;

      case v:
        var z = r & s;
        if (E || (E = u), t.size != e.size && !z) return !1;
        var k = P.get(t);
        if (k) return k == e;
        r |= p, P.set(t, e);
        var S = i(E(t), E(e), r, g, O, P);
        return P.delete(t), S;

      case _:
        if (x) return x.call(t) == x.call(e);
    }

    return !1;
  };
}, function (t, e, n) {
  var r = n(24).Uint8Array;
  t.exports = r;
}, function (t, e) {
  t.exports = function (t) {
    var e = -1,
        n = Array(t.size);
    return t.forEach(function (t, r) {
      n[++e] = [r, t];
    }), n;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = -1,
        n = Array(t.size);
    return t.forEach(function (t) {
      n[++e] = t;
    }), n;
  };
}, function (t, e, n) {
  var r = n(275),
      o = 1,
      a = Object.prototype.hasOwnProperty;

  t.exports = function (t, e, n, i, c, u) {
    var s = n & o,
        p = r(t),
        l = p.length;
    if (l != r(e).length && !s) return !1;

    for (var f = l; f--;) {
      var b = p[f];
      if (!(s ? b in e : a.call(e, b))) return !1;
    }

    var h = u.get(t);
    if (h && u.get(e)) return h == e;
    var y = !0;
    u.set(t, e), u.set(e, t);

    for (var m = s; ++f < l;) {
      var v = t[b = p[f]],
          d = e[b];
      if (i) var _ = s ? i(d, v, b, e, t, u) : i(v, d, b, t, e, u);

      if (!(void 0 === _ ? v === d || c(v, d, n, i, u) : _)) {
        y = !1;
        break;
      }

      m || (m = "constructor" == b);
    }

    if (y && !m) {
      var w = t.constructor,
          j = e.constructor;
      w != j && "constructor" in t && "constructor" in e && !("function" == typeof w && w instanceof w && "function" == typeof j && j instanceof j) && (y = !1);
    }

    return u.delete(t), u.delete(e), y;
  };
}, function (t, e, n) {
  var r = n(276),
      o = n(277),
      a = n(119);

  t.exports = function (t) {
    return r(t, a, o);
  };
}, function (t, e, n) {
  var r = n(193),
      o = n(35);

  t.exports = function (t, e, n) {
    var a = e(t);
    return o(t) ? a : r(a, n(t));
  };
}, function (t, e, n) {
  var r = n(278),
      o = n(279),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      c = i ? function (t) {
    return null == t ? [] : (t = Object(t), r(i(t), function (e) {
      return a.call(t, e);
    }));
  } : o;
  t.exports = c;
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length, o = 0, a = []; ++n < r;) {
      var i = t[n];
      e(i, n, t) && (a[o++] = i);
    }

    return a;
  };
}, function (t, e) {
  t.exports = function () {
    return [];
  };
}, function (t, e, n) {
  var r = n(281),
      o = n(99),
      a = n(35),
      i = n(107),
      c = n(120),
      u = n(108),
      s = Object.prototype.hasOwnProperty;

  t.exports = function (t, e) {
    var n = a(t),
        p = !n && o(t),
        l = !n && !p && i(t),
        f = !n && !p && !l && u(t),
        b = n || p || l || f,
        h = b ? r(t.length, String) : [],
        y = h.length;

    for (var m in t) {
      !e && !s.call(t, m) || b && ("length" == m || l && ("offset" == m || "parent" == m) || f && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || c(m, y)) || h.push(m);
    }

    return h;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = Array(t); ++n < t;) {
      r[n] = e(n);
    }

    return r;
  };
}, function (t, e) {
  t.exports = function () {
    return !1;
  };
}, function (t, e, n) {
  var r = n(50),
      o = n(109),
      a = n(51),
      i = {};
  i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, t.exports = function (t) {
    return a(t) && o(t.length) && !!i[r(t)];
  };
}, function (t, e, n) {
  (function (t) {
    var r = n(126),
        o = "object" == _typeof(e) && e && !e.nodeType && e,
        a = o && "object" == _typeof(t) && t && !t.nodeType && t,
        i = a && a.exports === o && r.process,
        c = function () {
      try {
        var t = a && a.require && a.require("util").types;

        return t || i && i.binding && i.binding("util");
      } catch (t) {}
    }();

    t.exports = c;
  }).call(this, n(78)(t));
}, function (t, e, n) {
  var r = n(286)(Object.keys, Object);
  t.exports = r;
}, function (t, e) {
  t.exports = function (t, e) {
    return function (n) {
      return t(e(n));
    };
  };
}, function (t, e, n) {
  var r = n(40)(n(24), "DataView");
  t.exports = r;
}, function (t, e, n) {
  var r = n(40)(n(24), "Promise");
  t.exports = r;
}, function (t, e, n) {
  var r = n(40)(n(24), "Set");
  t.exports = r;
}, function (t, e, n) {
  var r = n(40)(n(24), "WeakMap");
  t.exports = r;
},,,,,,,,,,,, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(0),
      o = n.n(r),
      a = n(10),
      i = n.n(a),
      c = n(1),
      u = n.n(c),
      s = n(37),
      p = n.n(s),
      l = (n(485), n(201));
  n.d(e, "MapPopup", function () {
    return l.a;
  });
  var f = n(202);
  n.d(e, "MapControls", function () {
    return f.a;
  });
  var b = n(203);
  n.d(e, "ZoomControl", function () {
    return b.a;
  });

  var h = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      y = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function m(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var v,
      d = ("undefined" != typeof window ? window : {}).L;
  "undefined" != typeof window && (v = d.GridLayer.prototype._initTile, d.GridLayer.include({
    _initTile: function _initTile(t) {
      v.call(this, t);
      var e = this.getTileSize();
      t.style.width = e.x + 1 + "px", t.style.height = e.y + 1 + "px";
    }
  }));

  var _ = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, a = Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }

      return n = r = m(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.events = {}, r.setMap = function () {
        var t = r.props.mapOptions;
        r.map = d.map(r.mapNode, h({}, e.defaultProps.mapOptions, t));
      }, r.setBasemap = function () {
        var t = r.props.basemap;
        r.basemapLayer && r.basemapLayer.remove(), r.basemapLayer = d.tileLayer(t.url, t.options).addTo(r.map).setZIndex(0);
      }, r.setLabel = function () {
        var t = r.props.label;
        r.labelLayer && r.labelLayer.remove(), r.labelLayer = d.tileLayer(t.url, t.options).addTo(r.map).setZIndex(1100);
      }, r.setBounds = function () {
        var t = r.props.bounds,
            e = t.bbox,
            n = t.options;

        if (e) {
          var o = [[e[1], e[0]], [e[3], e[2]]];
          r.map.fitBounds(o, n);
        }
      }, m(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["Component"]), y(e, [{
      key: "componentDidMount",
      value: function value() {
        if (void 0 !== d && this.mapNode) {
          var t = this.props,
              e = t.interactionEnabled,
              n = t.scrollZoomEnabled,
              r = t.onReady;
          this.setMap(), this.setBasemap(), this.setLabel(), this.setBounds(), this.setEvents(), e || (this.map.dragging.disable(), this.map.touchZoom.disable(), this.map.doubleClickZoom.disable(), this.map.scrollWheelZoom.disable(), this.map.boxZoom.disable(), this.map.keyboard.disable()), n || this.map.scrollWheelZoom.disable(), r(this.map), this.forceUpdate();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.basemap,
            n = t.label,
            r = t.bounds,
            o = t.events,
            a = this.props,
            i = a.basemap,
            c = a.label,
            u = a.bounds,
            s = a.events;
        p()(e, i) || this.setBasemap(), p()(n, c) || this.setLabel(), p()(r, u) || this.setBounds(), p()(o, s) || this.setEvents();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.removeEvents();
      }
    }, {
      key: "setEvents",
      value: function value() {
        var t = this,
            e = this.props.events;
        this.removeEvents(), Object.keys(e).forEach(function (n) {
          t.events[n] = function (r) {
            e[n](r, t.map);
          }, t.map.on(n, t.events[n]);
        });
      }
    }, {
      key: "removeEvents",
      value: function value() {
        var t = this;
        Object.keys(this.events).forEach(function (e) {
          t.map.off(e, t.events[e]);
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this,
            a = this.props,
            c = a.customClass,
            u = a.children,
            s = i()((n = !!c, (e = c) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return o.a.createElement("div", {
          className: (s ? s + " " : "") + "wri_api__c-map"
        }, o.a.createElement("div", {
          ref: function ref(t) {
            r.mapNode = t;
          },
          className: "wri_api__map-container"
        }), !!this.map && "function" == typeof u && u(this.map));
      }
    }]), e;
  }();

  _.propTypes = {
    children: u.a.func,
    customClass: u.a.string,
    mapOptions: u.a.object,
    basemap: u.a.object,
    label: u.a.object,
    bounds: u.a.object,
    events: u.a.object,
    interactionEnabled: u.a.bool,
    scrollZoomEnabled: u.a.bool,
    onReady: u.a.func
  }, _.defaultProps = {
    children: null,
    customClass: null,
    mapOptions: {
      zoomControl: !1,
      center: [27, 12],
      zoom: 3,
      maxZoom: 20,
      minZoom: 2
    },
    basemap: {
      url: "http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
      options: {
        maxZoom: 20,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    label: {
      url: "http://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png",
      options: {
        maxZoom: 20,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    bounds: {
      bbox: null,
      options: {}
    },
    events: {},
    interactionEnabled: !0,
    scrollZoomEnabled: !0,
    onReady: function onReady() {}
  }, e.default = _;
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
  t.exports = {
    "c-map": "wri_api__c-map",
    "map-container": "wri_api__map-container"
  };
},, function (t, e, n) {
  t.exports = {
    "c-map-controls": "wri_api__c-map-controls",
    "map-controls-list": "wri_api__map-controls-list",
    "map-controls-list-item": "wri_api__map-controls-list-item"
  };
},, function (t, e, n) {
  t.exports = {
    "c-zoom-control": "wri_api__c-zoom-control",
    "zoom-control-btn": "wri_api__zoom-control-btn",
    "-disabled": "wri_api__-disabled"
  };
}]);